import { useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MainContext } from "../../../../../Context/MainContext";
import { Link } from "react-router-dom";
import axios from "axios";
import "./DashboardNav.css";

const DashboardNav = (props) => {
  const navigate = useNavigate();
  const { setUser } = useContext(MainContext);
  const navListRef = useRef();

  useEffect(() => {
    if (navListRef.current.childNodes) {
      Array.from(navListRef.current.childNodes)
        .reverse()
        .forEach((node, i, arr) => {
          node.style.background = `rgba(0,135,254,${i / (arr.length - 1)})`;
        });
    }
  }, [navListRef]);

  function handleLogout() {
    axios
      .delete("/auth/logout")
      .then((res) => {
        console.log(res.data);
        setUser(null);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <nav id="dashboard-nav">
      <ul ref={navListRef}>
        <Link to="keygen">
          <li>KEYGEN</li>
        </Link>
        <Link to="titlegen">
          <li>T-GEN</li>
        </Link>
      </ul>
      <section className="dashboard-nav__user-controls icon_container--border-top">
        <button className="icon_container--sub" onClick={handleLogout}>
          <svg
            className="icon_svg icon_svg--sub"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
            />
            <path
              fillRule="evenodd"
              d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
            />
          </svg>
          <p className="icon_container-sub-text">LOGOUT</p>
        </button>
        {/* </div> */}
      </section>
    </nav>
  );
};

export default DashboardNav;
